export default __webpack_public_path__ + "static/maria-80219b0e0bbb65ddc11335759bdbfa13.png";